import styled, { css } from 'styled-components'
import Flex from 'src/components/Layout/Flex/Flex'
import { InputWrapper, SelectMain, SelectOptions, SelectWrapper } from 'src/components/Atoms/Dropdown/Dropdown.styles'
import { CheckboxContainer, CheckboxLabel } from 'src/components/Atoms/Checkbox/Checkbox.styles'

export const DropdownWrapperStyles = styled(Flex)<{wrapperMinHeight?: string, gridArea?: string, wrapperWidth?: string, disabled?: boolean}>`
  width: ${props => props.wrapperWidth || '100%'};
  justify-content: flex-start;
  align-items: ${props => props.alignItems || 'flex-start'};

  ${props => props.wrapperMinHeight && css`
      min-height: ${props.wrapperMinHeight};
  `}

  ${props => props.gridArea && css`
      grid-area: ${props.gridArea};
  `}

  ${InputWrapper}{
      width: 100%;
  }

  ${SelectOptions}{
      padding-block: 16px;
  }

  ${CheckboxContainer}{
      min-height: 0;
  }

  ${CheckboxLabel}{
      margin-bottom: 0;
  }

  ${props => props.disabled && css`
      ${InputWrapper} {
        cursor: not-allowed;
      }

      ${SelectWrapper} {
        cursor: not-allowed;
        pointer-events: none;
      }

      ${SelectMain} {
        background-color: ${props => props.theme.colors.shades.neutral[0]};

        path {
          fill: ${props => props.theme.colors.shades.neutral[1]};
        }
      }
  `}

`
